// Used for HeaderMenu Modals (Signin, Cart)
import React, { useContext } from 'react';
import useDimensions from 'react-use-dimensions';
import { Link } from 'react-router-dom';

import ModalContext from '../modal/ModalContext';
import useWindowSize from '../../hooks/useWindowSize';
import clientOnly from '../../hoc/clientOnly';

import './FlyOutModal.module.css';
import { withTranslation } from 'react-i18next';

const FlyOutModal = ({
  children,
  modalWidth,
  modalContent,
  id,
  clickTarget,
  t
}) => {
  const windowSize = useWindowSize();
  const [ref, size] = useDimensions();
  const { showModal } = useContext(ModalContext);

  const { right, width, height, bottom, top } = size;

  // position in center under button
  const buttonCenter = right - width / 2;
  let leftOffset = buttonCenter - modalWidth / 2;
  const paddingTop = bottom + 30;

  // add a optional click target for original button link
  const clickTargetOffset = buttonCenter - leftOffset - width / 2;

  // position relative to window if it would render outside viewport
  if (windowSize.width - leftOffset - modalWidth < 0) {
    leftOffset = windowSize.width - modalWidth - 25;
  }

  const arrowOffset = buttonCenter - leftOffset;

  const content = () => (
    <div styleName="offset" style={{ left: leftOffset, paddingTop }}>
      {clickTarget ? (
        <Link to={clickTarget} aria-label={t('Open in new modal')}>
          <div
            style={{
              position: 'absolute',
              top,
              left: clickTargetOffset,
              width,
              height
            }}
          />
        </Link>
      ) : null}
      <div styleName="content" style={{ width: modalWidth }}>
        {modalContent}
        <div styleName="arrow" style={{ left: arrowOffset + 9 }} />
      </div>
    </div>
  );

  const open = () => {
    showModal(content, id);
  };

  return (
    <div
      ref={ref}
      styleName="menu"
      onMouseEnter={open}
      onTouchStart={open}
      role="menuitem"
      tabIndex="0"
    >
      {children}
    </div>
  );
};

export default withTranslation()(clientOnly(FlyOutModal));
